import { render, staticRenderFns } from "./orderinfo2.vue?vue&type=template&id=06817f36&scoped=true&"
import script from "./orderinfo2.vue?vue&type=script&lang=js&"
export * from "./orderinfo2.vue?vue&type=script&lang=js&"
import style0 from "./orderinfo2.vue?vue&type=style&index=0&id=06817f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06817f36",
  null
  
)

export default component.exports